module.exports = __webpack_public_path__ + "media/images/default/pages/shared/search-1aafdd763930641f243220d08bc2ae7f.svg";